import { render, staticRenderFns } from "./MaterialTypeQgPanel.vue?vue&type=template&id=a4c0e550&"
import script from "./MaterialTypeQgPanel.vue?vue&type=script&lang=js&"
export * from "./MaterialTypeQgPanel.vue?vue&type=script&lang=js&"
import style0 from "./MaterialTypeQgPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports